import { render, staticRenderFns } from "./UserEvaluationComponent_v2.vue?vue&type=template&id=6522fe0f&scoped=true&"
import script from "./UserEvaluationComponent_v2.vue?vue&type=script&lang=js&"
export * from "./UserEvaluationComponent_v2.vue?vue&type=script&lang=js&"
import style0 from "./UserEvaluationComponent_v2.vue?vue&type=style&index=0&id=6522fe0f&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6522fe0f",
  null
  
)

export default component.exports